/**
 * @fileoverview Shared form label atom.
 * @description Renders a <label> in one of two text treatments — the medium-weight style used
 * above an input, or the lighter inline style used next to a checkbox — chosen via a prop so two
 * conflicting color/weight classes are never both present on the same element.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  variant?: 'field' | 'inline'
}

/**
 * @component
 * @param {LabelProps} props - Standard label attributes plus a variant.
 * @param {'field' | 'inline'} [props.variant] - "field" (default) for a label above an input;
 * "inline" for a label sitting next to a checkbox.
 */
function Label({ variant = 'field', ...props }: LabelProps) {
  const variantClassName =
    variant === 'inline'
      ? 'text-[15px] font-normal text-slate'
      : 'text-[15px] font-medium text-label'

  return <label className={variantClassName} {...props} />
}

export default Label
